import { Alert, Snackbar } from "@mui/material"
import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"

import { ReactComponent as UploadSvg } from "../../../assets/img/upload.svg"

import "./style.css"

const FileUpload = (props) => {
	const { t } = useTranslation()
	const [isDragging, setIsDragging] = useState<boolean>(false)
	const [isMultiple, setIsMultiple] = useState<boolean>(true)
	const [errorSnackbar, setErrorSnackbar] = useState<string | undefined>(
		undefined
	)
	const { data, dispatch } = props
	const refHiddenInput = useRef(null)

	const handleDragEnter = (e) => {
		e.preventDefault()
		e.stopPropagation()
		setIsDragging(true)
	}
	const handleDragLeave = (e) => {
		e.preventDefault()
		e.stopPropagation()
		dispatch({ type: "IS_IN_DROP_ZONE", inDropZone: false })
		setIsDragging(false)
	}

	const handleDragOver = (e) => {
		e.preventDefault()
		e.stopPropagation()
		e.dataTransfer.dropEffect = "copy"

		setIsDragging(true)
		dispatch({ type: "IS_IN_DROP_ZONE", inDropZone: true })
	}

	const handleDrop = (e) => {
		e.preventDefault()
		e.stopPropagation()

		setIsDragging(false)
		let files
		if (isMultiple) {
			files = e.dataTransfer ? [...e.dataTransfer.files] : [...e.target.files]
		} else {
			files = e.dataTransfer ? [e.dataTransfer.files[0]] : [e.target.files[0]]
		}

		if (files && files.length > 0) {
			if (files.length > 1 && !isMultiple) {
				setErrorSnackbar("snackbar.error.single")
			}
			const existingFiles = data.filesList.map((f) => f.name)
			files = isMultiple
				? files.filter((f) => !existingFiles.includes(f.name))
				: files[0]

			dispatch({
				type: isMultiple ? "ADD_FILE_TO_LIST" : "UPDATE_FILE_TO_LIST",
				files,
			})
			dispatch({ type: "IS_IN_DROP_ZONE", inDropZone: false })
			props.setIsConfirm(true)
		}
	}

	return (
		<div className="containerUploader">
			<div
				className={
					data.inDropZone ? "containerDrop inside-drag-area" : "containerDrop"
				}
				onDrop={(e) => handleDrop(e)}
				onDragOver={(e) => handleDragOver(e)}
				onDragEnter={(e) => handleDragEnter(e)}
				onDragLeave={(e) => handleDragLeave(e)}
				style={{ backgroundColor: isDragging ? "#ADD8E6" : "inherit" }}
			>
				<UploadSvg
					style={{
						width: "50vw",
						height: "42vw",
						maxWidth: "300px",
						maxHeight: "230px",
					}}
				/>

				<div
					style={{
						marginBottom: "32px",
					}}
				>
					<b>{t("dropZone.description1", { ns: "upload" })}</b>{" "}
					{t("dropZone.description2", { ns: "upload" })}
					<input
						ref={refHiddenInput}
						type="file"
						name="filesMultiple"
						id="fileUpload"
						style={{ display: "none" }}
						aria-label="Carica documenti"
						multiple={isMultiple}
						accept={".csv, .xlsx, .xls"}
						onChange={(e) => handleDrop(e)}
						onClick={(event) =>
							/** serve ad gestire una pulizia e conseguente caricamento dello stesso file */
							(event.target.value = "")
						}
					/>
					<span
						onClick={() => {
							refHiddenInput.current.click()
						}}
						style={{ color: "#458DBD", fontSize: "20px", cursor: "pointer" }}
					>
						{" "}
						{t("dropZone.buttons.upload", { ns: "upload" })}
					</span>
				</div>
			</div>
			{!!errorSnackbar && (
				<Snackbar
					sx={{ width: "calc(100% - 50px)" }}
					anchorOrigin={{ vertical: "top", horizontal: "left" }}
					open={!!errorSnackbar}
					autoHideDuration={20000}
					onClose={() => setErrorSnackbar(undefined)}
				>
					<Alert
						onClose={() => setErrorSnackbar(undefined)}
						severity="warning"
						variant="filled"
						sx={{ width: "100%" }}
					>
						{t(errorSnackbar, { ns: "upload" })}
					</Alert>
				</Snackbar>
			)}
		</div>
	)
}

export default FileUpload
